import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import jvDocPdf from '../image/JV Document.pdf'
import emailSwipesPdf from '../image/Ledaszora emails Pdf.pdf'

const DOCS = {
  jvdoc: { title: 'JV Document', src: jvDocPdf },
  swipes: { title: 'Email Swipes', src: emailSwipesPdf },
}

export default function PdfViewer() {
  const { docType } = useParams()
  const doc = DOCS[docType] || DOCS.jvdoc

  useEffect(() => {
    document.title = `${doc.title} | Leadszora 2.0`
  }, [doc.title])

  return (
    <div style={{ width: '100vw', height: '100vh', background: '#0f172a' }}>
      <iframe
        title={doc.title}
        src={doc.src}
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  )
}
